import "./EndGame/end-game.css"
import { connect } from 'react-redux';
import { initializeApp, setInfo } from '../../redux/actionList';
import { Button } from "react-bootstrap";
import {Component} from 'react';
import ReactPlayer from "react-player";
import LeaderBoardModal from '../game-views/leader_board_modal';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import {calculateMoodRetirementScores} from '../game-views/objects/calculate_mood_retirement_scores';
import MoodRetirementStatusModal from "../game-views/mood_retirement_status_modal";
import { standardNumberFormat } from "../../objects/CommonUse/double_functions";
import {getCurrentDateTime} from "../../objects/CommonUse/get_current_date_time";
import WaitTimeSpinner from "../shared-components/wait_time_spinner";
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import { calcMonthlyIncome } from "../../objects/CommonUse/calcMonthlyIncome";
import FinancialAdvisorModal from "../shared-components/financial_advisor_modal";
import ReasonForGameEndText from "./text/reason_for_game_end_text";
import InformationModal from "../shared-components/information_modal";
import replaceTextInString from "../../objects/CommonUse/replace_text_in_string";
import AppInitializer from "../appInitializer";


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameInfo: state,
    gameData: state.gameData,
    creditCardInfo: state.creditCardInfo,
    savingsInfo: state.savingsInfo,
    gamePurchases:  state.gamePurchases,
    timeWizardInfo: state.timeWizardInfo,
    funStuffInfo: state.funStuffInfo,
    investmentSaving: state.investmentSaving,
    summaryInvestment: state.summaryInvestment,
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
    initializeApp: initializeApp,
};

class EndGame extends Component {
    constructor(props) {
        super(props);        
        this.state = {
            callRender: false,
            modalOpen: false,
            headers: setHeadersForFetch(),
            accountNbr: "game",
            updateLeaderBoard: false,
            dateObj: getCurrentDateTime(),
            subProcess: "endGame",
            environment: Config.dataURL.currentEnv,
            archiveData: false,
            gameArchived: false,
            deleteData: false,
            gameDeleted: false,
            creditCardDeleted: false,
            savingsDeleted: false,
            funStuffDeleted: false,
            timeWizardDeleted: false,
            gamePurchasesDeleted: false,
            activityTrackerDeleted: false,
            gameInvestmentsDeleted: false,
            openFinModal: true,
            initializeApp: false
        }
        this.finishType = "fullGame";
        this.status = "InitialDisplay";
        this.moodScore = 0;
        this.retirementScore = 0;
        this.combinedScore = 0;
        this.archivesInitiated = false;
        this.deletesInitiated = false;
        this.returnToHomePageInitiated = false;
        this.totalNbrGameYears = (this.props.totalNbrGameMonths / 12).toFixed(0);
        this.openInformationModal = false;
        this.initialProcess();
    }    

    initialProcess(){
        this.determineEndOfGameText();
        this.calculateFinalScores();
        if (this.props.endGameReason !== "TimeElapsed"){
             this.finishType = "forceEnd";
        }
    }

    determineEndOfGameText(){
        const endGameTextObj = ReasonForGameEndText.find(elem => elem.reason === this.props.endGameReason);
        this.endGameTitle = endGameTextObj.title;
        this.endGameText = endGameTextObj.text;
        if (this.endGameText.includes("||")){
            let replaceObj = { string: this.totalNbrGameYears };
            this.endGameText =
                replaceTextInString(this.endGameText, replaceObj, "totalNbrGameYears", "string");
        }
    }

    calculateFinalScores(){
        let totalInvestments = 0;
        if (this.props.summaryInvestment.length > 0){
            const summaryInvestments = this.props.summaryInvestment;
            totalInvestments = summaryInvestments.find(elem => elem.investType === "all").currentValue;
        }
        let gameScores = calculateMoodRetirementScores(this.props.gameData.currentMoodPoints,
            this.props.gameData.currentCash, this.props.savingsInfo.totalSavingsAmt, totalInvestments,
            this.props.gameData.assetTable, this.props.gameData.currentGameDate);
        this.moodScore = (+gameScores.moodScore).toFixed(0);
        this.retirementScore = (+gameScores.retirementScore).toFixed(0);
        this.combinedScore = +gameScores.combinedScore;
    }

     
    displayMoodRetirementModal(){
        this.status = "DisplayMoodRetirement";
        this.setState({modalOpen: true});
    }

    render() {
        if (this.state.archiveData === true & this.archivesInitiated === false){
            this.archiveGameRelatedCollections();
        }
       
        if (this.deletesInitiated === false && this.state.gameArchived === true  ){
            this.deleteGameRelatedCollections();
        }

        if (this.returnToHomePageInitiated === false && this.state.gameDeleted === true &&
            this.state.creditCardDeleted === true && this.state.savingsDeleted === true &&
            this.state.funStuffDeleted === true && this.state.timeWizardDeleted === true &&
            this.state.activityTrackerDeleted === true && this.state.gamePurchasesDeleted === true &&
            this.state.gameInvestmentsDeleted === true){
                this.openInformationModalDisplay();
        }

                       
    return <>
             <div className="col-8">
                <div className="card mt-3 mr-3 rounded-corners-lg text-center height-max">
                    <h3 className="mt-2">Finish Playing Your Game</h3> 
                    <div className="mt-4">
                        <h4>{this.endGameTitle}</h4>
                        <div className="mx-4 mt-2 text-left">
                            {this.endGameText}                       
                        </div>
                    </div>
                
                    <div className="mt-4 mx-4 ">
                        <h4>Final Game Scores</h4>
                        <table className="row justify-content-center gameChoiceModalHdrFtrBackground ">
                            <tbody>
                                <tr>
                                    <th className="col-sm-8 text-left">Game Item</th>
                                    <th className="col-sm-4 text-right">Score</th>
                                </tr>
                                <tr>
                                    <td className="col-sm-8 text-left">Mood Score</td>
                                    <td className="col-sm-4 text-right">{standardNumberFormat(this.moodScore)}</td>
                                </tr>
                                <tr>
                                    <td className="col-sm-8 text-left">Retirement score</td>
                                    <td className="col-sm-4 text-right">{standardNumberFormat(this.retirementScore)}</td>
                                </tr>
                                <tr>
                                    <th className="col-sm-8 text-left">Combined Score</th>
                                    <th className="col-sm-4 text-right">{standardNumberFormat(this.combinedScore)}</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {this.status === "DisplayMoodRetirement" ?
                        <MoodRetirementStatusModal modalOpen={this.state.modalOpen} 
                            onClose={(moodRetirementScoreObj) => this.saveScores(moodRetirementScoreObj)}
                            gameInfo = {this.props.gameInfo}
                        />
                    :
                        null
                    }
                    {this.status === "DisplayLeaderBoard" ?
                        <div>
                            <LeaderBoardModal modalOpen={this.state.modalOpen} 
                                playerSelected={true}    
                                accountNbr={this.state.accountNbr}
                                finishType={this.finishType}
                                onClose={(updateLeaderBoard) => this.closeLeaderBoardModal(updateLeaderBoard)} 
                                gameInfo = {this.props.gameInfo}
                            />
                        </div>
                    :
                        null
                    }       
                    {this.status === "DisplayVideo" ?
                        <span className="mt-0 ml-0">  
                            <div className="videoDisplay">
                                <ReactPlayer className="videoDisplay" 
                                    url="./assets/video.mp4" type="video/mp4" playing 
                                    onClick ={()=> this.turnVideoOff()}
                                    onEnded = {()=>this.turnVideoOff()}
                                />
                           </div>
                       </span>
                    :
                        <div className="mt-4">   
                            <img src="./assets/sidebar_icon.png" className="train_icon_endgame_img mr-5"
                                alt="train"/>   
                        </div>  
                    }
                    
                    {this.status === "InitialDisplay" ?
                        <div className= "text-right mt-4">
                            <Button variant="primary"  onClick={() => this.displayMoodRetirementModal()}>
                                End My Game
                            </Button>
                            {this.props.endGameReason === "PlayersChoice" ?
                                <Button className="mx-2" variant="secondary"  onClick={() => this.goToGameBoard()}>
                                    Back to GameBoard
                                </Button>
                            :
                                null
                            }
                        </div>
                    :   
                            null
                    }

                    {this.status === "FinancialAdvice"  ?
                        <FinancialAdvisorModal 
                            modalOpen = {this.state.openFinModal}
                            gameInfo = {() => this.props.gameInfo}
                            adviceType = {"endGame"}
                            monthlyTotalAmt ={this.monthlyTotalAmt}
                            expenseTable={this.props.gameData.expenseTable}
                            onClose = {() => this.closeFinancialAdvisorModal()}
                        />
                    :
                        null
                    }

                    {this.openInformationModal   ?
                        <InformationModal   
                            time={5000}
                            show={this.openInformationModal}
                            infoCode={this.informationCode}
                            onClose={() => this.closeInformationModal()}
                        />
                    :
                        null
                    }

                    {this.status === "DisplayTrainVideo" ?
                       <WaitTimeSpinner />
                    :
                        null
                    }

                    {this.state.initializeApp  ?
                         <AppInitializer onComplete={() => this.goToHomePage()} />
                    :
                        null
                    }
                </div>
                  
            </div>
      </>
    }

turnVideoOff(){
    this.status = "displayTrainVideo";
    this.setState({modalOpen: true});
}

goToGameBoard(){
    this.props.onNavigate("game-board");
}
 
goToHomePage(){
    this.props.onNavigate("");
}

saveScores(scoreObj){
    this.retirementScore = scoreObj.retirementScore;
    this.moodScore = scoreObj.moodScore;
    this.combinedScore = scoreObj.combinedScore;
    this.closeModal("MoodRetirement");
}

closeModal(){
     if (this.status === "DisplayMoodRetirement"){
        this.status = "DisplayLeaderBoard";
        this.setState({modalOpen: true});
     }else{
        this.setState({modalOpen: false});
     }
}

closeLeaderBoardModal(updateLeaderBoard){
    if (updateLeaderBoard === true){
        this.updateLeaderBoard();
    }
    this.monthlyIncomeObj = calcMonthlyIncome(this.props.gameData.assetTable,
        this.props.gameData.expenseTable, this.props.gameData.loanTable);
    this.monthlyTotalAmt = this.monthlyIncomeObj.income;
    this.status = "FinancialAdvice";
    this.setState({callRender: true});
}

closeFinancialAdvisorModal(){
    this.status = ""
    // the following turns off the fireworks video... if decide to add back, need to determine
    // when it should be displayed (current seems way too late in the end game process)
    //  if (this.props.endGameReason === "TimeElapsed"){
    //      this.status = "DisplayVideo"
    // }else{
    this.status = "DisplayTrainVideo";
    // }
    this.setState({archiveData: true});
}

archiveGameRelatedCollections(){
    this.archivesInitiated = true;
    this.saveArchivedGame();
    this.saveArchivedActivityTracker();
    const feature = this.props.gameData.unlockedFeatures.find(elem => elem.featureName === "moneyBuilder");
    if (feature && feature.level >= 3){
        // saveArchived also deletes gameInvestments
        this.saveArchivedGameInvestments();
    }else{
        this.setState({gameInvestmentsDeleted:  true});
    }
    if (!this.props.creditCardInfo.gameID){
        this.setState({creditCardDeleted: true});
    }else{
        this.saveArchivedCreditCardInfo();
    }
    if (!this.props.savingsInfo.gameID){
        this.setState({savingsDeleted: true});
    }else{
        //  saveArchived also deletes savingsInfo
        this.saveArchivedSavingsAmounts();
    }
    if (!this.props.funStuffInfo.gameID){ 
        this.setState({funStuffDeleted: true});
    }else{   
        this.saveArchivedFunStuff();
    }
    if (!this.props.gamePurchases.gameID){ 
        this.setState({gamePurchasesDeleted: true});
    }else{   
        this.saveArchivedGamePurchases();
    }
    
}

deleteGameRelatedCollections(){
    this.deletesInitiated = true;
    this.deleteGame();
    if (!this.props.timeWizardInfo.gameID){
        this.setState({timeWizardDeleted: true});
    }else{
        this.deleteTimeWizard();
    }
 
}

openInformationModalDisplay(){
    this.informationCode = "EndGame";
    this.openInformationModal = true;
}

closeInformationModal(){
    this.returnToHomePageInitiated = true;
    this.setState({initializeApp: true});
}

updateLeaderBoard(){
    let currentDateTime = getCurrentDateTime();
    const nbrMonthsPlayed = +this.props.totalNbrGameMonths - +this.props.gameData.gameNbrMonths;
    let bodyObj = {
        user: this.props.gameData.user,
        startGameDate: this.props.gameData.startGameDate,
        moodScore: this.moodScore,
        retirementScore: this.retirementScore,
        combinedScore: this.combinedScore,
        nbrGameMonths: nbrMonthsPlayed,
        account: "game",
        dateUpdated: currentDateTime.date,
    };
    const funcName = "saveLeaderBoard";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {
            method:'POST',
            headers: this.state.headers,
            body: JSON.stringify(bodyObj)
    })
    .then(response => {
        if (response.ok){
            response.json().then(data => {
            const output = JSON.parse(data);
            const statusCode = output.statusCode;
            if (statusCode === 200){
               //  update was successful
            }else{
                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                    status: statusCode, message: output.body.message, errorObject: bodyObj};
                this.props.processError(errorObj);
            }
        });
        }
    });
}

saveArchivedGame() {
    this.gameID = this.props.gameData._id;
    if (!this.props.gameData.gameTemplate){
        this.props.gameData = {...this.props.gameData, gameTemplate: "none"};
    }
    let timeWizardInfo = {};
    if (this.props.timeWizardInfo ){ 
        timeWizardInfo = this.props.timeWizardInfo;
    }
    this.bodyObj = { ...this.props.gameData, timeWizardInfo: timeWizardInfo};
    const funcName = "saveArchivedGameData";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
            {
            method:'POST',
            headers: this.state.headers,
            body: JSON.stringify(this.bodyObj)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.setState({gameArchived: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: this.bodyObj};
                        this.props.processError(errorObj);
                    }
                });
                }
            });
}

saveArchivedActivityTracker(){
    const gameID = this.props.gameData._id;
    const userName = this.props.gameData.user;
    // note that the archiveDelete function does a load of gameInvestments before the archiveDelete
    const funcName = "archiveDeleteActivityTracker";
    const urlParm = "?gameID=" + gameID + "&user=" + userName;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {
            method:'POST',
            headers: this.state.headers,
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.setState({activityTrackerDeleted: true});
                }else{
                    const urlObj={urlParm: urlParm};
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message, errorObject: urlObj};
                    this.props.processError(errorObj);
                }
            });
            }
        });
}

saveArchivedGameInvestments(){
    const gameID = this.props.gameData._id;
    const userName = this.props.gameData.user;
    // note that the archiveDelete function does a load of gameInvestments before the archiveDelete
    const funcName = "archiveDeleteGameInvestments";
    const urlParm = "?gameID=" + gameID + "&user=" + userName;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {
            method:'POST',
            headers: this.state.headers,
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.setState({gameInvestmentsDeleted: true});
                }else{
                    const urlObj = {urlParm: urlParm};
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message, errorObject: urlObj};
                    this.props.processError(errorObj);
                }
            });
            }
        });
}

saveArchivedCreditCardInfo(){
    let bodyObj = {...this.props.creditCardInfo, user: this.props.gameData.user};
    const funcName = "archiveDeleteCreditCard";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {
            method:'POST',
            headers: this.state.headers,
            body: JSON.stringify(bodyObj)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.setState({creditCardDeleted: true});
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message, errorObject: bodyObj};
                    this.props.processError(errorObj);
                }
            });
            }
        });
}

saveArchivedSavingsAmounts(){
    this.clearOutTaxArr();
    let bodyObj = {...this.props.savingsInfo, user: this.props.gameData.user};
    const funcName = "archiveDeleteSavings";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
    {
        method:'POST',
        headers: this.state.headers,
        body: JSON.stringify(bodyObj)
    })
    .then(response => {
        if (response.ok){
            response.json().then(data => {
            const output = JSON.parse(data);
            const statusCode = output.statusCode;
            if (statusCode === 200){
                this.setState({savingsDeleted: true});
            }else{
                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                    status: statusCode, message: output.body.message, errorObject: bodyObj};
                this.props.processError(errorObj);
            }
        });
        }
    });
}

clearOutTaxArr(){
    let savingsArr = this.props.savingsInfo.savingsArr;
    for (let i=0; i<savingsArr.length; i++){
        savingsArr[i].taxHistoryArr.length = 0;
    }
}

saveArchivedFunStuff(){
    let bodyObj = {...this.props.funStuffInfo, user: this.props.gameData.user};
    const funcName = "archiveDeleteFunStuff";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
    {
        method:'POST',
        headers: this.state.headers,
        body: JSON.stringify(bodyObj)
    })
    .then(response => {
        if (response.ok){
            response.json().then(data => {
            const output = JSON.parse(data);
            const statusCode = output.statusCode;
            if (statusCode === 200){
                this.setState({funStuffDeleted: true});
            }else{
                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                    status: statusCode, message: output.body.message, errorObject: bodyObj};
                this.props.processError(errorObj);
            }
        });
        }
    });
}

saveArchivedGamePurchases(){
    let bodyObj = {...this.props.gamePurchases, user: this.props.gameData.user};
    const funcName = "archiveDeleteGamePurchases";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
    {
        method:'POST',
        headers: this.state.headers,
        body: JSON.stringify(bodyObj)
    })
    .then(response => {
        if (response.ok){
            response.json().then(data => {
            const output = JSON.parse(data);
            const statusCode = output.statusCode;
            if (statusCode === 200){
                this.setState({gamePurchasesDeleted: true});
            }else{
                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                    status: statusCode, message: output.body.message, errorObject: bodyObj};
                this.props.processError(errorObj);
            }
        });
        }
    });
}

deleteTimeWizard(){
    const funcName = "deleteTimeWizard";
    const urlParm = "?gameID=" + this.gameID;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
    {
            method:'DELETE',
            headers: this.state.headers
    })
    .then(response => {
        if (response.ok){
            response.json().then(data => {
            const output = JSON.parse(data);
            const statusCode = output.statusCode;
            if (statusCode === 200){
                this.setState({timeWizardDeleted: true});
            }else{
                const parmObj={gameID: this.gameID};
                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                    status: statusCode, message: output.body.message, errorObject: parmObj};
                this.props.processError(errorObj);
            }
        });
        }
    });
}   

deleteEventTrackeForGame(){
    const funcName = "deleteEventTrackerForGame";
    const urlParm = "?gameID=" + this.gameID;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {
            method:'DELETE',
            headers: this.state.headers
    })
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                   //  Event Tracker has been deleted;
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        };
    })
}

deleteGame() {
    const funcName = "endGame";
    const urlParm = "?rcdKey=" + this.gameID;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
    {
            method:'DELETE',
            headers: this.state.headers
    })
    .then(response => {
        if (response.ok){
            response.json().then(data => {
            const output = JSON.parse(data);
            const statusCode = output.statusCode;
            if (statusCode === 200){
                this.setState({gameDeleted: true});
            }else{
                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                    status: statusCode, message: output.body.message};
                this.props.processError(errorObj);
            }
        });
        }
    });
}
   
}

export default  connect(mapStateToProps, mapDispatchToProps)(EndGame);